module.exports = __webpack_public_path__ + "img/chart.bbcf8687.svg";